module.exports = __webpack_public_path__ + "img/ergo-essential4.08dcae88.png";